import React, { useRef } from "react";
import styled from "styled-components";

import { RichContentDisplay } from "@examspark/common-ui";
import { Stem } from "@examspark/types";

import { useDrag } from "../../hooks/useDnd";

import { DndItem } from "./Token";

const StyledToken = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  line-height: 2em;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #eee;
  }

  ${RichContentDisplay} {
    padding: 0.2rem;
  }
`;

type TextGapTokenProps = {
  data: Stem.Option;
  gapId: string;
  instanceId: string;
  onTokenRemove: () => void;
};
const TextGapToken = (props: TextGapTokenProps) => {
  const ref = useRef(null);

  const item: DndItem = {
    type: "token",
    id: props.data.id,
    gapId: props.gapId,
    instanceId: props.instanceId,
    maxUsage: props.data.maxUsage,
  };

  useDrag(ref, {
    item,
    end: (item, monitor) => {
      // remove the token if it was dropped into whitespace
      if (!monitor.didDrop() && item) {
        props.onTokenRemove();
      }
    },
  });

  return (
    <StyledToken ref={ref} className="item-player-gap-token">
      <RichContentDisplay
        key={props.data.id}
        content={props.data.body}
        inline
      />
    </StyledToken>
  );
};

export default TextGapToken;
